import { render, staticRenderFns } from "./EmptyServices.vue?vue&type=template&id=5ad52cd7&scoped=true"
import script from "./EmptyServices.vue?vue&type=script&lang=js"
export * from "./EmptyServices.vue?vue&type=script&lang=js"
import style0 from "./EmptyServices.vue?vue&type=style&index=0&id=5ad52cd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad52cd7",
  null
  
)

export default component.exports